import {
    ISymbolSizeConfig,
    ISymbolStateConfig
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {GGReelSymbol} from "./GGReelSymbol";
import {TimelineLite, TweenLite} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {GGGameConfig} from "../GGGameConfig";
import {FontStyleConfig} from "../config/FontStyleConfig";

export class GGReelSymbolM extends GGReelSymbol {
    private static readonly BG_TINT_COLOR:{ [symname:string]:string } = {
        "M1_bg" : "#612a88",
        "M2_bg" : "#b53308",
        "M3_bg" : "#2c9b8a",
        "M4_bg" : "#6965b5",
        "M5_bg" : "#7e152f",
    };
    private _multiplierValue:number;
    private _explosion:PIXI.spine.Spine;
    private _multiplier:PIXI.BitmapText;
    private _wildCloth:PIXI.Sprite;

    private get multiplier():number {
        return this._multiplierValue;
    }

    private set multiplier(value:number) {
        this._multiplierValue = value;
    }
    constructor(symName:string, reelId:number, state?:ISymbolStateConfig, size?:ISymbolSizeConfig) {
        super(symName, reelId, state, size);
    }

    protected initState(stateConfig:ISymbolStateConfig):boolean {
        if(super.initState(stateConfig)) {
            //this.patchMultiplier(Math.floor(100*Math.random()));
            if(this._symFrame) {
                this._symFrame.texture = GameResources.getTextures(`${this.symName}_size${this.symSize}_frame`)[0];
                this.addChild(this._symFrame);
            }

            if(this._multiplier) {
                this.updateMultiplierSize();
                this.addChild(this._multiplier);
            }
            return true;
        }
        return false;
    }

    protected createSpineAnimation(spineName:string):PIXI.spine.Spine {
        const spineAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset(spineName));
        spineAnimation.pivot.set(0.5, 0.5);
        spineAnimation.position.set(0, 0);
        spineAnimation.renderable = false;
        spineAnimation.visible = false;
        spineAnimation.name = spineName;
        return spineAnimation;
    }

    private createMultiplier():void {
        this._multiplier = new PIXI.BitmapText("x4", FontStyleConfig.Evil4MultiplierOnSymbol);
        (<PIXI.Point> this._multiplier.anchor).set(0.5, 0.5);
        this._multiplier.visible = false;
    }

    public createMiddleLayerGraphics():void {
        if(!this._wildCloth) {
            this._wildCloth = this.createEmptySprite("");
            this._wildCloth.alpha = 0;
            this.addChild(this._wildCloth);
        }
    }

    public patchMultiplier(multiplier:number, withAnimation:boolean = false):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        if(!this._multiplier) {
            this.createMultiplier();
        }
        if(this._multiplier.text === "x" + multiplier.toString() && this._multiplier.visible){
            return tl;
        }
        if(withAnimation){
            tl.add(this.playHighlightAnimation());
        }

        tl.add(()=>{
            this.multiplier = multiplier;
            this._multiplier.text = "x" + multiplier.toString();
            this.updateMultiplierSize();
            this._multiplier.visible = true;
            this.addChild(this._multiplier);
        });
        return tl;
    }

    private updateMultiplierSize():void {
        const scale:number = ((this.multiplier>9 || this.symSize>5)?0.6:1);
        this._multiplier.scale.set(scale, scale);
        this._multiplier.position.set(0, this.symHeight*0.3);
    }

    public updateBackground(symHeight:number):void {
        this.addChild(this._symFrame);
        this.scale.y = 1;
        if(!(this.currentState === GGGameConfig.instance.SYMBOL_STATES.explode)){
            this.replaceWith(this.symName, this.reelId, this.currentState!, {
                height : this.symHeight
            });
            if(this._multiplier){
                this.updateMultiplierSize();
            }
        }
        this._symBackground.texture = GameResources.getTextures(`M_size${this.symSize}_bg`)[0];
        this._symBackground.width = 100;
        this._symFrame.texture = GameResources.getTextures(`${this.symName}_size${this.symSize}_frame`)[0];
        this._symBackground.tint = parseInt((GGReelSymbolM.BG_TINT_COLOR[this.symName+"_bg"]).replace(/^#/, ''), 16);
        this._displayScale = this.calDisplayScale(symHeight);

   }

    public getExplodeAnimation(stateAnimation:TimelineSprite):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        if(this._multiplier){
            tl.add(new TweenLite(this._multiplier, 0.3, {alpha : 0, delay:0.73}));
        }

        tl.add([
            () => {
                this._explosion = this.createSpineAnimation(this.symName + "Explosion");
                this.addChild(this._explosion);

                // #416
                if(this._symFrame){
                    this.addChild(this._symFrame);
                }

                if(this._multiplier){
                    this.addChild(this._multiplier);
                }
                this._explosion.renderable = true;
                this._explosion.visible = true;
                this._explosion.state.setAnimation(0, `Size_${this.symSize}`, false);
            },
            new TweenLite(stateAnimation, 0.1, {alpha : 0}),
            new TweenLite(this._symFrame, 0.2, {alpha : 0, delay:0.7}),
            new TweenLite(this._symBackground, 0.2, {alpha : 0, delay:0.7})
        ], 0);
        tl.add(() => {
            for(let stateName in this._stateAnimations) {
                const state = this._stateAnimations[stateName];
                if(state != null) {
                    state.visible = false;
                }
            }
        }, 0.33);
        tl.add(() => {
            this._explosion.renderable = false;
            this._explosion.visible = false;
        }, 1.33);
        return tl;
    }


    public onRemove():void {
        super.onRemove();
        if(this._multiplier) {
            this.removeChild(this._multiplier);
        }

        if(this._explosion) {
            this.removeChild(this._explosion);
        }

        if(this._wildCloth) {
            this.removeChild(this._wildCloth);
        }
    }

}